import { phoneDigits } from './validators';

/** Override em runtime vindo de GET /api/config (staging pode ligar sem rebuild do bundle). */
let runtimeSkipPhoneVerification: boolean | null = null;

export function setRuntimeSkipPhoneVerification(skip: boolean | null): void {
  runtimeSkipPhoneVerification = skip;
}

/** Dígitos locais BR (10 ou 11), sem código do país. */
export function normalizeBrazilPhoneDigits(value: string): string {
  let digits = phoneDigits(value);
  if (digits.startsWith('55') && digits.length >= 12) {
    digits = digits.slice(2);
  }
  return digits;
}

export function toBrazilE164(value: string): string {
  const digits = normalizeBrazilPhoneDigits(value);
  if (digits.length < 10 || digits.length > 11) {
    throw new Error('invalid-phone');
  }
  return `+55${digits}`;
}

export function maskPhone(value: string): string {
  const digits = normalizeBrazilPhoneDigits(value);
  if (digits.length < 10) return value;
  const ddd = digits.slice(0, 2);
  const last = digits.slice(-4);
  return `(${ddd}) •••••-${last}`;
}

export function phonesMatch(a: string, b: string): boolean {
  return normalizeBrazilPhoneDigits(a) === normalizeBrazilPhoneDigits(b);
}

/**
 * OTP/SMS desligado se o build (VITE_*) ou o backend (APP_SKIP_PHONE_VERIFICATION) disser true.
 */
export function isPhoneVerificationSkipped(): boolean {
  if (import.meta.env.VITE_SKIP_PHONE_VERIFICATION === 'true') return true;
  return runtimeSkipPhoneVerification === true;
}
